// extracted by mini-css-extract-plugin
module.exports = {"table":"SitesWithMostIncidentsTile_table__bRb8V","index":"SitesWithMostIncidentsTile_index__XrP0V"};